








import { Component, Vue } from 'vue-property-decorator';
import gql from 'graphql-tag';
import store from '@/store';
import Login from '@/components/Login.vue';

const ApolloOptions = Vue.extend({
  apollo: {
    user: {
      query: gql`
        query User {
          user {
            id
            role
            centers {
              centerId
              isAdmin
            }
          }
        }
      `,
      skip() {
        return !store.getters['auth/authenticated'];
      },
    },
  },
});

@Component({
  components: {
    Login,
  },
  watch: {
    user() {
      (this as AdminLogin).checkRole();
    },
  },
})
export default class AdminLogin extends ApolloOptions {
  public user: {
    id: string,
    role: 'user' | 'system_admin' | 'center_admin',
    centers: Array<{ centerId: string, isAdmin: boolean }> | null,
  } | null = null;

  public checkRole() {
    const u = this.user;
    if (!u) { return; }

    if (!/(system_admin|center_admin)/gi.test(u.role)) {
      store.dispatch('auth/deleteAuthToken');
    } else {
      const adminOfCenters = (u.centers && u.centers.filter((c) => c.isAdmin)) || [];
      const centerId = adminOfCenters.length === 1 ? adminOfCenters[0].centerId : null;
      this.$router.push(`/selectGame?mode=manage${centerId ? ('&centerId=' + centerId) : ''}`);
    }
  }

  public onLogin() {
    /* stub */
  }
}
